export enum NextStepSelectValue {
  EndAutomation = 'end',
  NextPrompt = 'next',
  NewAutomation = 'new',
  OpenLink = 'openLink',
  SendAMessage = 'sendAMessage', // Deprecated, from the legacy automation builder
}
